/** @jsx jsx **/
import { jsx } from "@emotion/react";
import React, { useContext } from "react";

import { DetermineMobileContext } from "@modules";
import { checkWebView } from "@func";

import ServiceCenter from "./servicecenter";
import SiteMap from "./sitemap";
import SNSList from "./snslist";
import Policies from "./policies";
import CompanyInfo from "./companyinfo";
import Isms from "./isms";
import StoreButtons from "./appstores";
import WebViewFooter from "./webviewfooter";

import * as styles from "./footer.style";

export default function Footer() {
  const isMobile = useContext(DetermineMobileContext);
  const isWebView = checkWebView();

  return (
    <>
      {isWebView ? (
        <WebViewFooter />
      ) : (
        <div css={styles.footer}>
          <div css={styles.centerBox}>
            <div css={styles.topBox}>
              <ServiceCenter />
              <SiteMap />
            </div>
            <div css={styles.pcPolicySNS}>
              <Policies />
              {!isMobile && <SNSList />}
            </div>
            <CompanyInfo />
            {!isMobile && (
              <div css={styles.ismsBox}>
                <Isms />
              </div>
            )}
            {isMobile && (
              <>
                <div css={styles.mobileSNSIsmsDiv}>
                  <SNSList />
                  <Isms />
                </div>
                <StoreButtons />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
